module.exports = __webpack_public_path__ + "static/media/kids-baking-course.7d4a2ef6.webp";